'use strict';
import getUrlParams from '../utils/url/url-get-params';
import CheckoutExpressConstants from '../../constants/checkout-express-constants';
import HelperStorageCheck from '../utils/helper/helper-storage-check';

var _init = function () {
	let params = getUrlParams(),
		now = new Date(),
		affiliationDetails = HelperStorageCheck.isLocalStorageAvailable() && JSON.parse(localStorage.getItem(CheckoutExpressConstants.AFFILIATION)) || {};
	if (affiliationDetails && affiliationDetails.value && affiliationDetails.expiry && now.getTime() > affiliationDetails.expiry) {
		localStorage.removeItem(CheckoutExpressConstants.AFFILIATION);
	}
	if (params['at_gd'] && HelperStorageCheck.isLocalStorageAvailable()) {
		let AffiliationItem = {
			value: params['at_gd'],
			expiry: now.getTime() + (CheckoutExpressConstants.AFFILIATION_EXPIRATION_TIME)
		};
		localStorage.setItem(CheckoutExpressConstants.AFFILIATION, JSON.stringify(AffiliationItem));
	}
};

_init();



// WEBPACK FOOTER //
// ./src/components/apps/app-affiliation.jsx